import BASE_URL from '@naruto/bgdcms/src/base/url';
import ADMIN_PAGE_KEY from '@naruto/bgdcms/src/base/routes/AdminPageKey';
import { Routes } from '@naruto/bgdcms/src/base/routes/types';

const ADMIN_URL = BASE_URL.ADMIN;

const Admin: Routes = {
  main: [
    {
      id: ADMIN_PAGE_KEY.ACCOUNT_OVERVIEW,
      route: `${ADMIN_URL.ROOT_PAGE_ACCOUNT_OVERVIEW}`,
      component: import('@naruto/bgdcms/src/components/Pages/Account/AccountOverview'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    },
    {
      id: ADMIN_PAGE_KEY.ACCOUNT_DETAIL_UPDATE,
      route: `${ADMIN_URL.ROOT_PAGE_ACCOUNT_DETAIL_TYPE}${ADMIN_URL.ROOT_PAGE_ACCOUNT_DETAIL}`,
      component: import('@naruto/bgdcms/src/components/Pages/Account/AccountDetail'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    },
    {
      id: ADMIN_PAGE_KEY.ACCOUNT_DETAIL_CREATE,
      route: `${ADMIN_URL.ROOT_PAGE_ACCOUNT_DETAIL_TYPE}`,
      component: import('@naruto/bgdcms/src/components/Pages/Account/AccountDetail'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    }
  ]
};

export default Admin;
